import axios from 'axios';

const basePath = '/web-api/shipping';

export const all = (payload = null, config = {}) =>
    axios.get(
        basePath + '/methods',
        config
    );

export default {
    all
}